export const NOTHS_REFERER_REGEX = /^(.*notonthehighstreet.*|.*noths.*)/;
export const BASKET_PAGE_PATH = '/cart';
